export const HomePageExplore = [
    {
        tag: 'Free',
        courses: [
            {
                heading: "Learn HTML",
                description: "Begin your web journey by grasping the essentials of HyperText Markup Language, the building blocks of the internet.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Learn CSS",
                description: "Cultivate the skills to artistically style web content, using Cascading Style Sheets to enhance visual appeal.",
                level: 'Beginner',
                lessionNumber: 6
            },
            {
                heading: "Responsive Web design",
                description: "Master crafting adaptable websites. Acquire fluid layout and media query skills for seamless user experiences on diverse devices.",
                level: 'Beginner',
                lessionNumber: 6
            },
        ]
    },
    {
        tag: 'New to coding',
        courses: [
            {
                heading: "HTML",
                description: "Start your coding expedition with HTML, the foundational language for structuring websites and web applications.",
                level: 'Beginner',
                lessionNumber: 4
            },
            {
                heading: "CSS",
                description: "Forge a strong design foundation by understanding CSS, the tool to beautify and layout your web creations.",
                level: 'Beginner',
                lessionNumber: 9
            },
            {
                heading: "JavaScript ",
                description: "Embark on a coding adventure, mastering JavaScript to breathe life into your web projects with interactivity.",
                level: 'Beginner',
                lessionNumber: 7
            },
        ]
    },
    {
        tag: 'Most popular',
        courses: [
            {
                heading: "Java",
                description: "Embark on a programming journey with Java, a versatile language known for its application in enterprise software and beyond.",
                level: 'Intermediate',
                lessionNumber: 13
            },
            {
                heading: "Python",
                description: "Discover Python, the beginner-friendly language hailed for its readability and vast range of applications.",
                level: 'Beginner',
                lessionNumber: 10
            },
            {
                heading: "SCSS",
                description: "Elevate your CSS prowess using SCSS, a dynamic stylesheet language amplifying your styling capabilities.",
                level: 'Beginner',
                lessionNumber: 6
            },
        ]
    },
    {
        tag: 'Skills paths',
        courses: [
            {
                heading: "Flask",
                description: "Journey into Flask and harness the power of Python to create and deploy web applications with simplicity and agility.",
                level: 'Intermediate',
                lessionNumber: 17
            },
            {
                heading: "Django",
                description: "Master Django's high-level framework to efficiently craft web applications, focusing on clean design and robust functionality.",
                level: 'Intermediate',
                lessionNumber: 14
            },
            {
                heading: "Fast API",
                description: "Dive into FastAPI, leveraging Python's efficiency to construct speedy and modern APIs with ease and accuracy.",
                level: 'Intermediate',
                lessionNumber: 15
            },
        ]
    },
    {
        tag: 'Career paths',
        courses: [
            {
                heading: "Next.js",
                description: "Explore Next.js and learn to create server-rendered React applications, with fluid client-side navigation for enhanced user experiences.",
                level: 'Advanced',
                lessionNumber: 25
            },
            {
                heading: "Nuxt.js",
                description: "Uncover Nuxt.js and its ability to simplify building universal Vue.js applications, enabling efficient server-side rendering.",
                level: 'Advanced',
                lessionNumber: 16
            },
            {
                heading: "Sanity",
                description: "Learn Sanity to streamline content management, employing a customizable and collaborative CMS platform for seamless content delivery.",
                level: 'Advanced',
                lessionNumber: 20
            },
        ]
    },
]